import React from 'react';
import { Container, Row, Col, Image, Button, Nav } from "react-bootstrap";
import {
    FaInfoCircle,
    FaCodeBranch,
    FaPinterestP,
    FaInstagram,
    FaFacebookF,
    FaTwitter,
    FaLinkedinIn,
    FaYoutube,
} from "react-icons/fa";
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from "react-router-dom";

import Logo from '../../assets/images/RetinaLogoSquare.png';

import './footer.module.css'

const Footer = () => {
    return (
        <div>
            <footer>
                <Container>
                    {/* <Row>
                        <Col xs={12} md={12}>
                            <div styleName="footer-logo-wrap">
                                <LinkContainer to="/">
                                    <Image styleName="footer-logo" src={Logo} />
                                </LinkContainer>
                            </div>
                        </Col>
                    </Row> */}
                    <hr />
                    <Row className="mt-4 mt-md-5 pt-1 pt-md-4 pb-1 pb-md-0">
                        <Col className="align-self-center mb-5 mb-md-0" xs={12} md={4}>
                            <Link to='/'>
                                <img src={Logo} alt="Retina" className='footer-logo' />
                            </Link>
                        </Col>
                        <Col xs={12} md={8}>
                            <Row>
                                <Col className="mb-3 mb-md-0" xs={6} md={4}>
                                    <div className="quick-link-header">
                                        <span className="order-1">কোম্পানি</span>
                                    </div>
                                    <Nav as="ul" className="quick-links mt-3">
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                            <Link to='/about'>আমাদের সম্পর্কে</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                            <Link to='/gallery/photos'>গ্যালারি</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                            <Link to='/privacy-policy'>প্রাইভেসি পলিসি</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                            <Link to='/terms-and-conditions'>শর্তাবলী</Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col className="mb-3 mb-md-0" xs={6} md={3}>
                                    <div className="quick-link-header">
                                        <span className="order-1 order-md-0">অন্যান্য লিঙ্ক</span>
                                    </div>
                                    <Nav as="ul" className="quick-links mt-3">
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                            <Link to='/blogs'>ব্লগ পড়ুন</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                            <Link to='/courses'>কোর্সসমূহ</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                            <Link to='/publications'>পাবলিকেশন</Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                            <Link to='/branches'>শাখাসমূহ</Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col className='mb-3 mb-md-0' xs={12} md={5}>
                                    <div className="quick-link-header">
                                        <span className="order-1">যোগাযোগ করুন</span>
                                    </div>
                                    <Nav as="ul" className="quick-links mt-3">
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                            <a href='tel:+8809677999666'>+8809677999666</a>
                                        </Nav.Item>
                                        <Nav.Item as="li" className='w-100 mb-1'>
                                        Email - <a href='mailto:info.retinabd@gmail.com'>info.retinabd@gmail.com</a>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </footer>
            <div className='pb-4' styleName="footer-bottom">
                <Container>
                    <Row>
                        <Col xs={12} md={12}>
                            <Nav as="ul" className="justify-content-center mb-3">
                                <Nav.Item as="li">
                                    <Nav.Link styleName="social-link" href="https://www.facebook.com/RetinaBd">
                                        <FaFacebookF />
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                    <Nav.Link styleName="social-link" href="https://www.instagram.com/retina.bd/">
                                        <FaInstagram />
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                    <Nav.Link styleName="social-link" href="https://twitter.com/retinabd">
                                        <FaTwitter />
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                    <Nav.Link styleName="social-link" href="https://www.linkedin.com/company/retina-bd/">
                                        <FaLinkedinIn />
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                    <Nav.Link styleName="social-link" href="https://www.youtube.com/RetinaBd">
                                        <FaYoutube />
                                    </Nav.Link>
                                </Nav.Item>
                                {/* <Nav.Item as="li">
                                    <Nav.Link styleName="social-link" href="https://www.pinterest.com/retinabd/">
                                        <FaPinterestP />
                                    </Nav.Link>
                                </Nav.Item> */}
                            </Nav>
                        </Col>
                        <Col className="align-self-center text-center" xs={12} md={12}>
                            <div className="text-secondary">© {new Date().getFullYear()} . Retina Medical & Dental Admission Coaching. All rights reserved. Developed by <a styleName="dl" href="https://durbinlabs.com"><span>Durbin</span> <span>Labs Ltd.</span></a></div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default Footer;